import { reset } from 'redux-form';
import {
  reset as resetAnnotations,
  cancelAnnotate,
} from 'store/services/annotations/actions';

import downloadFile from 'store/utils/downloadFile';

import * as api from '../api';
import { getImportedResources } from '../selectors';

export const PARTIAL_IMPORT_TYPES = {
  merge: 'merge',
  replace: 'replace',
};

const partialImportAction = type => {
  const partialImportFn =
    type === PARTIAL_IMPORT_TYPES.merge
      ? api.partialImportAndMerge
      : api.partialImportAndReplace;

  return configuration => ({ file }) => async dispatch => {
    const { path, types, postHook = () => null } = configuration;

    // Cancel any annotate request before partial Import
    dispatch(cancelAnnotate());

    dispatch({
      type: types.request,
    });

    try {
      const { data } = await partialImportFn(path, file);
      dispatch(reset(`${path}-partial-import`));

      dispatch(resetAnnotations());

      postHook(dispatch);

      dispatch({
        type: types.complete,
        payload: { importedResources: data },
        error: null,
      });
    } catch (err) {
      dispatch({
        type: types.complete,
        error: err,
      });

      throw err;
    }
  };
};

export const partialImportAndMergeAction = partialImportAction(
  PARTIAL_IMPORT_TYPES.merge,
);
export const partialImportAndReplaceAction = partialImportAction(
  PARTIAL_IMPORT_TYPES.replace,
);

export const downloadImportedResources = resourceName => () => (
  dispatch,
  getState,
) => {
  const importedResources = getImportedResources(getState(), resourceName);

  const importedResourcesJSON = JSON.stringify(importedResources, null, 2);

  downloadFile(importedResourcesJSON, `imported-${resourceName}-report.json`);
};
